<div class="separator"></div>

<style lang="scss">
    @import "../styles/main.scss";

    .separator {
        width: 1px;
        height: 54px; 
        align-self: stretch;
        background: rgba(246, 223, 206, 0.15); // Matches icon border color
        box-shadow: 
            -1px 0px 0px 0px rgba(250, 235, 215, 0.2),
            inset 0 1px 1px rgba(255, 255, 255, 0.05); // Similar to icon shadow
    }
</style> 